import styled from 'styled-components';
import ShareWhatsappSvg from '../../../assets/onboardingNew/homepage/share-whatsapp.svg';

const ShareWhatsappNewIcon = styled(ShareWhatsappSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '2rem'};
height: ${props => props.height || '2rem'};
display: flex;
`;

export default ShareWhatsappNewIcon;
